export const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || "";
export const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY || "";

export const DEFAULT_PEXELS_API_KEY = process.env.REACT_APP_PEXELS_API_KEY || "";
export const DEFAULT_PIXABAY_API_KEY = process.env.REACT_APP_PIXABAY_API_KEY || "";
export const DEFAULT_JAMENDO_CLIENT_ID = process.env.REACT_APP_JAMENDO_CLIENT_ID || "";
export const DEFAULT_ELEVENLABS_API_KEY =
  process.env.REACT_APP_ELEVENLABS_API_KEY || "dd8a78f58a9f7e55f8f34d3bd3f0eb0a";
export const DEFAULT_SEEDANCE_API_KEY =
  process.env.REACT_APP_SEEDANCE_API_KEY || "";
